module.exports = __webpack_public_path__ + "img/accordion-down.b064ff90.svg";